import React, { useContext, useState, useEffect, useRef, useMemo } from 'react'
import AuthContext from '../../context/AuthContext'
import { Breadcrumb, BreadcrumbItem, Tile } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast'
import { ProvincesList } from './provinces.tsx';

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, REACT_APP_DEV_MEDIA_URL, REACT_APP_PROD_MEDIA_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;
const MEDIA_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_MEDIA_URL : process.env.REACT_APP_DEV_MEDIA_URL;

const ProvincesSettings = ({ match }) => {
    // Variables for pagination
    const [totalItems, setTotalItems] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [firstRowIndex, setFirstRowIndex] = useState(0);

    // Variables for modals and toasts
    const [list, setList] = useState([]);
    let toastProperties = null;
    let [openAddModal, setOpenAddModal] = useState(false)
    let [openEditModal, setOpenEditModal] = useState(false)
    let [openDeleteModal, setOpenDeleteModal] = useState(false)
    let [editID, setEditID] = useState(null)
    let [deleteID, setDeleteID] = useState(null)
    let [error, setError] = useState(null)

    // Other Variables
    let { user, authTokens } = useContext(AuthContext)
    let [countries, setCountries] = useState([])
    let [provinces, setProvinces] = useState([])

    // Variables for Search
    const [countrySearch, setCountrySearch] = useState("");

    const addForm = useRef();
    const editForm = useRef();

    useEffect(() => {
        const getProvinces = async () => {
            let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
                method: 'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':'Bearer ' + authTokens?.access
                }
            })
            let data = await response.json()
            setProvinces(data)
        }
        const getCountries = async () => {
            let response = await fetch(`${API_URL}/system/referencedata/geographical/countries/`, {
                method: 'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':'Bearer ' + authTokens?.access
                }
            })
            let data = await response.json()
            setCountries(data)
        }
        getCountries()
        getProvinces()
        setTotalItems(provinces?.length)
        document.title = "Provinces Reference Data | WillowBMS"
    }, [])

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let getCountryList = async () => {
        let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
            method: 'GET',
            headers:{
                'Content-Type':'application/json',
                'Authorization':'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCountries(data)
    }
    
    let getProvinceList = async () => {
        let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
            method: 'GET',
            headers:{
                'Content-Type':'application/json',
                'Authorization':'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setProvinces(data)
    }

    let addCountry = async (values) => {
        values.preventDefault()

        let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'province': values.target.province.value,
                'provincecode': values.target.provincecode.value,
                'country': values.target.country.value,
                'common': values.target.common.value,
            })
        })

        if (response.status === 200) {
            getProvinceList()
            setOpenAddModal(false)
            showToast("success", "Success", "New province has been added.")
            setError(false)
            document.getElementById("addProvince").reset()
        } else {
            setError(true)
        }
    }

    let editCountry = async (values) => {
        values.preventDefault();
        let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': editID.id,
                'province': values.target.province.value,
                'provincecode': values.target.provincecode.value,
                'country': values.target.country.value,
                'common': values.target.common.value,
            })
        })

        if (response.status === 200) {
            getProvinceList()
            setOpenEditModal(false)
            showToast("success", "Success", "Province has been edited.")
            setError(false)
            document.getElementById("editProvince").reset()
        } else {
            setError(true)
        }
    }

    let editSetup = async (id) => {
        provinces?.map((country) => { country.id === id && setEditID(country) }
        )
    }

    let batchDelete = async (selectedCountries) => {
        selectedCountries.map((country) => deleteCountry(country.id))
    }

    let deleteCountry = async (provinceID) => {
        let response = await fetch(`${API_URL}/system/referencedata/geographical/provinces/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': provinceID,
            })
        })

        if (response.status === 200) {
            getProvinceList()
            setOpenDeleteModal(false)
            let deleteSuccessMessage = "Selected provinces (#" + provinceID + ") have been delete."
            showToast("success", "Success", deleteSuccessMessage)
            setError(false)
        } else {
            setError(true)
        }
    }

    const countriesHeaders = [
        { label: "Country Description", key: "country" },
        { label: "Country Code", key: "countrycode" }
    ];

    const countryData = useMemo(() => {
        let computedCountries = search(provinces);
        setTotalItems(computedCountries.length);
        //Current Page slice
        return computedCountries.slice(
            firstRowIndex,
            firstRowIndex + currentPageSize
        );
    }, [provinces, firstRowIndex, currentPageSize, countrySearch]);

    const csvCountryReport = {
        data: provinces,
        headers: countriesHeaders,
        filename: `WillowBMS_system_countries.csv`
    };

    function search(rows) {
        return rows.filter(
            (row) =>
                row.province.toLowerCase().indexOf(countrySearch) > -1 ||
                row.province.indexOf(countrySearch) > -1 ||
                row.provincecode.indexOf(countrySearch) > -1 ||
                row.provincecode.toLowerCase().indexOf(countrySearch) > -1 ||
                row.country.toLowerCase().indexOf(countrySearch) > -1 ||
                row.country.toLowerCase().indexOf(countrySearch) > -1
        );
    }

    return (
        <div id="body" className="bms-page d-flex">
            <Toast toastList={list} />
            <div className="wrapper">
                <Breadcrumb>
                    <BreadcrumbItem href="/system/settings/general">Settings</BreadcrumbItem>
                    <BreadcrumbItem href="/system/settings/reference-data">Reference Data</BreadcrumbItem>
                    <span>Provinces</span>
                </Breadcrumb>
                <h2>
                    Reference Data
                </h2>
                <Tile light={true} className="row mt-1">
                    <h5 className="tile-title mb-1">Provinces</h5>
                    <ProvincesList countries={countries} setDeleteID={setDeleteID} csvCountryReport={csvCountryReport} setCountrySearch={setCountrySearch} deleteID={deleteID} batchDelete={batchDelete} openDeleteModal={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal} editID={editID} editSetup={editSetup} editForm={editForm} openEditModal={openEditModal} setOpenEditModal={setOpenEditModal} editCountry={editCountry} addCountry={addCountry} addForm={addForm} openAddModal={openAddModal} setOpenAddModal={setOpenAddModal} error={error} setError={setError} rows={countryData} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} />
                </Tile>
            </div>
        </div>
    )
}

export default ProvincesSettings